import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import {
  addIncidentDetails,
  selectIncidentDetails,
  selectSelectedType,
} from '../../../../services/store/modules/incident-report';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';

import IncidentDetailsForm from '../components/IncidentDetailsForm/IncidentDetailsForm';
import useIncidentReportingLocation from '../hooks/useIncidentReportingLocation';

const IncidentDetailsPage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [selectedLatitude, selectedLongitude] = useIncidentReportingLocation();
  const selectedType = useSelector(selectSelectedType);
  const hydratedIncidentDetails = useSelector(selectIncidentDetails);

  const handleSubmit = async (data: {
    tags: string[];
    incidentDateTime: string;
  }) => {
    dispatch(addIncidentDetails(data));
    await captureEvent({
      type: 'incident: details entered',
      payload: {},
      sendToAmplitude: true,
    });
    history.push('description');
  };

  const handleBack = async () => {
    await captureEvent({
      type: 'incident: back to select location',
      payload: {},
      sendToAmplitude: true,
    });
    history.goBack();
  };
  return (
    <BasicDrawerLayout
      showMapOverlay
      showMenuBar={false}
      heading="Report an incident"
      onBack={handleBack}
    >
      {selectedLatitude && selectedLongitude ? (
        <IncidentDetailsForm
          tags={selectedType.availableTags}
          hydratedIncidentDetails={hydratedIncidentDetails}
          onSubmit={handleSubmit}
        />
      ) : null}
    </BasicDrawerLayout>
  );
};

export default IncidentDetailsPage;
